export default "__VITE_ASSET__BZ7n2zuU__"